import 'jquery-validation';
if (lang == "zh-TW") {
    const jqueryValidationLang = require('jquery-validation/dist/localization/messages_zh_TW.min.js');
} else if (lang == "zh-CN") {
    const jqueryValidationLang = require('jquery-validation/dist/localization/messages_zh.min.js');
} else if (lang == "id-ID") {
    const jqueryValidationLang = require('jquery-validation/dist/localization/messages_id.min.js');
} else if (lang == "th-TH") {
    const jqueryValidationLang = require('jquery-validation/dist/localization/messages_th.min.js');
} else if (lang == "ko-KR") {
    const jqueryValidationLang = require('jquery-validation/dist/localization/messages_ko.min.js');
} else if (lang == "ja-JP") {
    const jqueryValidationLang = require('jquery-validation/dist/localization/messages_ja.min.js');
} else if (lang == "my-MM") {
    (function (factory) {
        if (typeof define === "function" && define.amd) {
            define(["jquery", "../jquery.validate"], factory);
        } else if (typeof module === "object" && module.exports) {
            module.exports = factory(require("jquery"));
        } else {
            factory(jQuery);
        }
    }(function ($) {
        $.extend($.validator.messages, {
            required: "my-MM必須填寫",
            remote: "my-MM請修正此欄位",
            email: "my-MM請輸入有效的電子郵件"
        });
        return $;
    }));
} else if (lang == "vi-VN") {
    const jqueryValidationLang = require('jquery-validation/dist/localization/messages_vi.min.js');
}
import * as ScrollMagic from "scrollmagic";
import {
    TweenMax,
    TimelineMax
} from "gsap";
import {
    ScrollMagicPluginGsap
} from "scrollmagic-plugin-gsap";
import Swal from 'sweetalert2'
import '../sass/contact.sass';
import {
    library,
    dom
} from '@fortawesome/fontawesome-svg-core'
import {
    faCheck,
    // 以下共用
    faEnvelope,
    faGlobe,
    faArrowUp,
    faChevronRight,
} from '@fortawesome/free-solid-svg-icons'
import {
    // 以下共用
    faFacebookF,
    faYoutube,
    faXTwitter,
    faInstagram,
    faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons'

library.add(
    faCheck,
    faEnvelope,
    faGlobe,
    faArrowUp,
    faChevronRight,
    faFacebookF,
    faYoutube,
    faXTwitter,
    faInstagram,
    faLinkedinIn, )
dom.watch()


ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
var controller = new ScrollMagic.Controller();



var scene = new ScrollMagic.Scene({
        triggerElement: ".main-tit"
    })
    .setTween(".a01", .5, {
        x: "0px",
        "opacity": "1"
    })
    .addTo(controller);
var scene = new ScrollMagic.Scene({
        triggerElement: ".main-tit"
    })
    .setTween(".a02", .5, {
        x: "0px",
        "opacity": "1"
    })
    .addTo(controller);
var scene = new ScrollMagic.Scene({
        triggerElement: ".main-tit"
    })
    .setTween(".out", .7, {
        x: "0px",
        "opacity": "1"
    })
    .addTo(controller);



$(function () {

    // $.when(configJSON()).then(function(configData) {

    //         // Event snippet for 外連點擊-RSG conversion page In your html page, 
    //         // add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button
    //         function gtag_report_conversion(url) {
    //             var callback = function() { if (typeof(url) != 'undefined') { window.location = url; } };
    //             gtag('event', 'conversion', { 'send_to': configData.gaId + '/xZc2CLS80fEBEJLU_t8B', 'value': 1.0, 'currency': 'TWD', 'event_callback': callback });
    //             return false;
    //         }
    //     })
    //取得 input 內容
    function getInput(inputId) {
        var input = document.querySelector(inputId);
        return input.value != "" ? input.value : null;
    }

    // 取得 感興趣產品內容
    function getCheckedBoxes(chkboxName) {
        var checkboxes = document.getElementsByName(chkboxName);
        var checkboxesChecked = [];
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked) {
                checkboxesChecked.push(checkboxes[i].value);
            }
        }
        return checkboxesChecked.length > 0 ? checkboxesChecked : null;
    }




    //Google reCAPTCHA v3
    function sendMail(e) {

        //e.preventDefault();
        $.when(configJSON()).then(function (configData) {
            grecaptcha.ready(function () {
                grecaptcha.execute(configData.recaptchaKey, {
                    action: 'submit'
                }).then(function (token) {
                    let fields = {
                        name: getInput("#f-name"),
                        tel: getInput("#f-tel"),
                        interest: getCheckedBoxes("f-interest[]"),
                        email: getInput("#f-email"),
                        whatsapp: getInput("#f-whatsapp"),
                        skype: getInput("#f-skype"),
                        wechat: getInput("#f-wechat"),
                        qq: getInput("#f-qq"),
                        telegram: getInput("#f-telegram"),
                        message: getInput("#f-msg"),
                    };

                    let mailBody = "";

                    fields.name != null ? mailBody += '姓名：' + fields.name + '<br>' : "";
                    fields.tel != null ? mailBody += '電話：' + fields.tel + '<br>' : "";
                    fields.interest != null ? mailBody += '興趣產品：' + fields.interest + '<br>' : "";
                    fields.whatsapp != null ? mailBody += 'WhatsApp：' + fields.whatsapp + '<br>' : "";
                    fields.skype != null ? mailBody += 'Skype：' + fields.skype + '<br>' : "";
                    fields.wechat != null ? mailBody += 'WeChat：' + fields.wechat + '<br>' : "";
                    fields.qq != null ? mailBody += 'QQ：' + fields.qq + '<br>' : "";
                    fields.telegram != null ? mailBody += 'Telegram：' + fields.telegram + '<br>' : "";
                    fields.msg != null ? mailBody += '訊息：' + fields.message + '<br>' : "";


                    //console.log(mailBody)
                    $.ajax({
                        type: "POST",
                        //url: "http://192.168.30.242:6090/ContactUS",
                        url: configData.sendCheck,
                        async: true,
                        data: {
                            'data': JSON.stringify(fields),
                            'recaptcha_token': token
                        },
                        success: function (rtmsg) {
                            $.getJSON("../assets/json/lang/" + lang + "/contact.json", "", (data) => {
                                if (rtmsg.msg == "1") {

                                    Swal.fire({
                                        title: data.form_success_tit,
                                        text: data.form_success_txt,
                                        confirmButtonText: data.form_cls,
                                        width: 300,
                                        padding: 0,
                                        customClass: "contact_alert alert_success",
                                        buttonsStyling: false,
                                        confirmButtonClass: "block-btn yellow",
                                        showLoaderOnConfirm: true
                                    })
                                    document.getElementById("form").reset();

                                } else {
                                    Swal.fire({
                                        title: data.form_fail_tit,
                                        text: data.form_fail_txt,
                                        confirmButtonText: data.form_cls,
                                        width: 300,
                                        padding: 0,
                                        customClass: "contact_alert alert_error",
                                        buttonsStyling: false,
                                        confirmButtonClass: "block-btn yellow",
                                        showLoaderOnConfirm: true
                                    })

                                }
                            });
                        },
                        error: function () {
                            $.getJSON("../assets/json/lang/" + lang + "/contact.json", "", (data) => {
                                Swal.fire({
                                    title: data.form_fail_tit,
                                    text: data.form_fail_txt,
                                    confirmButtonText: data.form_cls,
                                    width: 300,
                                    padding: 0,
                                    customClass: "contact_alert alert_error",
                                    buttonsStyling: false,
                                    confirmButtonClass: "block-btn yellow",
                                    showLoaderOnConfirm: true
                                })
                            });

                        },
                        dataType: 'json'
                    });

                });
            });
        })

    }


    $("form").validate({
        //success: "valid",
        submitHandler: function () {

            //- 按下按鈕時跳出loading
            Swal.fire({
                title: '',
                width: 300,
                padding: 0,
                background: 'none',
                imageUrl: '../assets/images/send_loading.svg',
                showCancelButton: false, // There won't be any cancel button
                showConfirmButton: false // There won't be any confirm button
            })
            sendMail()
        },
        focusInvalid: false,
        invalidHandler: function (form, validator) {

            if (!validator.numberOfInvalids())
                return;
            $('html, body').animate({
                scrollTop: $(validator.errorList[0].element).offset().top - $('header').height() - 50
            }, 1000);

        },
        errorPlacement: function (error, element) {
            //$('.contact_bg').append(error)
            var eid = element.attr('name');
            if (element.is(':checkbox')) {
                $('.check-group').after(error);
            } else {
                $('input[name=' + eid + '] , textarea[name=' + eid + ']').parent().after(error);
            }
        }
    });

    fixedLeft(".contact_bg")


})